module.exports = __webpack_public_path__ + "img/ic_foot_hight_2.7bf2070a.png";